import type { CardData, Suit } from './types';

// Syndicate (2026-09): alcune coppie di suit, se sono le due suit del mazzo,
// sbloccano un bonus passivo con un nome. Il mazzo diventa una "banda" con
// un'identità riconoscibile (badge nel deck editor, nome in partita).
// I bonus si applicano a inizio partita (draft.onEnd) ritoccando parametri e
// stato degli effetti delle carte, oppure — Cartel — in play.onEnd.
// Vedi docs/card_ideas.md §4.
export type SyndicateId = 'demolition' | 'old_money' | 'high_rollers' | 'precinct' | 'cartel';

export interface Syndicate {
  id: SyndicateId;
  name: string;
  suits: [Suit, Suit];
  bonus: string;   // testo UI (inglese)
}

export const SYNDICATES: Syndicate[] = [
  { id: 'demolition',   name: 'The Demolition Crew', suits: ['cars', 'weapons'],
    bonus: 'Bombs blow after 2 rounds instead of 3.' },
  { id: 'old_money',    name: 'The Old Money',       suits: ['money', 'jewels'],
    bonus: 'Appreciating assets bank +2 per round instead of +1.' },
  { id: 'high_rollers', name: 'The High Rollers',    suits: ['casino chips', 'criminal contacts'],
    bonus: 'Slow-burn cards also charge while waiting in Hand 2.' },
  { id: 'precinct',     name: 'The Precinct',        suits: ['police', 'drug'],
    bonus: 'Lockdowns last 1 extra round.' },
  { id: 'cartel',       name: 'The Cartel',          suits: ['drug', 'money'],
    bonus: 'Every snatch pays +1 drug and +1 money.' },
];

export function syndicateFor(suits: readonly string[]): Syndicate | null {
  if (suits.length !== 2) return null;
  return SYNDICATES.find(s =>
    (s.suits[0] === suits[0] && s.suits[1] === suits[1]) ||
    (s.suits[0] === suits[1] && s.suits[1] === suits[0])) ?? null;
}

export function syndicateById(id: string | null | undefined): Syndicate | null {
  return SYNDICATES.find(s => s.id === id) ?? null;
}

// Ritocca gli effetti delle carte del mazzo secondo il bonus del Syndicate.
// Aggiorna anche il testo breve sulla carta, così il giocatore vede il
// valore effettivo. Da chiamare su carte già sanitizzate (mai dal client).
export function applySyndicate(cards: CardData[], id: SyndicateId): void {
  for (const c of cards) {
    for (const e of c.effects ?? []) {
      switch (id) {
        case 'demolition':
          if (e.kind === 'time_bomb') {
            e.state = { ...(e.state ?? {}), fuse: 2 };
            e.text = e.text.replace('3 rounds', '2 rounds');
          }
          break;
        case 'old_money':
          if (e.kind === 'ripening_loot') {
            e.params = { ...e.params, amount: 2 };
            e.text = e.text.replace('banks +1', 'banks +2');
          }
          break;
        case 'high_rollers':
          if (e.kind === 'held_charge') {
            e.params = { ...e.params, countDeck: true };
            e.text = `${e.text} Also charges in Hand 2.`;
          }
          break;
        case 'precinct':
          if (e.kind === 'freeze') {
            e.params = { ...e.params, turns: (e.params.turns ?? 2) + 1 };
            e.text = e.text.replace('2 rounds', '3 rounds');
          }
          break;
        case 'cartel':
          break; // bonus sugli snatch, gestito in Game.ts play.onEnd
      }
    }
  }
}
